<template>
	<div class='watch-main' >
		<div class="watch-left flex-column">
			<div class="watch-panel">
				<div class="panel-item flex-column jc-between">
					<span class="panel-value">{{panelData.equipmentNum}}</span>
					<span class="panel-name">监控总数(个)</span>
				</div>
				<div class="panel-item flex-column jc-between">
					<span class="panel-value">{{panelData.onlineNum}}</span>
					<span class="panel-name">在线总数(个)</span>
				</div>
				<div class="panel-item d-flex">
					<img class="panel-icon" src="@/assets/wms/offline.png" alt="">
					<div class="flex-column d-flex jc-between">
						<span class="panel-value-active">{{panelData.offlineNum}}</span>
						<span class="panel-name">离线(个)</span>
					</div>
				</div>
				<div class="panel-item d-flex">
					<img class="panel-icon" src="@/assets/wms/move.png" alt="">
					<div class="flex-column d-flex jc-between">
						<span class="panel-value-active">{{panelData.moveNum}}</span>
						<span class="panel-name">移动(个)</span>
					</div>
				</div>

			</div>
			<div class="watch-menu" v-loading="loading">
				<el-tree :data='menuData' icon-class=' ' :props="defaultProps" @node-click="handleNodeClick">
					<template #default="{node, data}">
						<template v-if="data.childrenList ">
							<div class="custom-node-container">
								<span v-if="node.expanded"
									class=" expanded el-tree-node__expand-icon el-icon-caret-right"></span>
								<span v-else class=" el-tree-node__expand-icon el-icon-caret-right"></span>
								<span
									class="custom-node-text-noleaf ">{{ data.labelName }}&nbsp;&nbsp;({{ data.onlineNum+"/"+data.equipmentNum }})</span>
							</div>
						</template>
						<template v-else>
							<span class="custom-node-text-leaf" style="padding-left: 0.26rem;">{{ data.labelName||data.equipmentName }}</span>
						</template>
					</template>
				</el-tree>
			</div>

		</div>
		<div class="watch-right">
			<div class='video-warp'>
				<div class='video-list'>
					<div class="video-item" :class="'video-item-'+pageSize" v-for='i in pageSize'>

						<div v-if='playerList[i-1]' class="myPlayWind">
							<div class="myPlayWind" :id="'playWind-'+(i-1)"></div>
						</div>



						<img v-else src="@/assets/wms/coverPicture.png" :id="'playPic'+(i+pageSize*(pageNo-1)-1)"
							alt="">


					</div>
				</div>
			</div>

			<div class="pagination">
				<el-pagination :page-sizes="[4, 9, 16]" :page-size='pageSize' :current-page.sync='currentPage'
					@current-change='handleCurrentChange' background layout="prev, pager, next"
					:total="videoList.length">
				</el-pagination>
			</div>

		</div>

	</div>

</template>

<script>
	import {
		menuData
	} from './menu.js';
	import { Message } from 'element-ui'
	import {
		ezvizUrl,
		watchList
	} from "@/api/wms/index.js";
	import EZUIKit from '@/assets/js/ezuikit.js';
	export default {

		name: 'watchList',
		props: {
			pageSize: {
				type: Number,
				default: 4
			},
		},
		data() {
			return {
				panelData:{
					equipmentNum:0,
					onlineNum:0,
					offlineNum:0,
					moveNum:0
				},
				loading: false,
				pageNo: 1,
				currentPage: 1,
				videoList: [],
				activeIndex: '1',
				menuData: [],
				defaultProps: {
					children: 'childrenList',
					label: 'labelName',
					isLeaf: 'isLeaf'
				},
				playerList: []
			}
		},
		watch: {
			pageSize(e) {
				this.currentPage = 1
				this.initPlayer()
			}
		},
		created() {
			
			this.menuData = menuData
			this.getWatchList()
		},
		methods: {
			async getWatchList(val){
				let {data}=await watchList({superviseId:val})
				console.log(data)
				if(data.code==200){
					this.menuData=data.result.childrenList
					const {equipmentNum,onlineNum,offlineNum,moveNum}=data.result
					this.panelData={equipmentNum,onlineNum,offlineNum,moveNum}
					console.log(this.menuData)
				}
			},
			initPlayer() {
				console.log('initPlayer', this.playerList)
				this.playerList.forEach(item => {
					try{
						item.player.stop();
						item.player.destroy();
						item.player = null
						console.log(item)
					}catch(e){
						console.log(item)
					}
					
				})
				this.playerList = []
				let newVideoList = this.videoList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this
					.pageSize)
				console.log((this.currentPage) * this.pageSize, this.currentPage * this.pageSize)
				console.log(this.videoList)
				console.log(newVideoList, '---------------------------------------------------------')
				for (let i = 0; i < newVideoList.length; i++) {
					this.playerList.push({
						loading: true,
						player: null
					})
					// this.$nextTick(()=>{

					this.createDom(newVideoList[i].accessToken, newVideoList[i].url, this.playerList.length - 1)
					// })
				}
				// newVideoList.forEach(item=>{
				// 	this.playerList.push({})
				// 	this.$nextTick(()=>{

				// 		this.createDom(item.accessToken, item.url)
				// 	})

				// })
			},
			handleCurrentChange(e) {
				console.log('翻页了', e)
				console.log(this.currentPage, this.pageNo)
				// this.currentPage=e
				this.initPlayer()

			},
			async handleNodeClick(e) {
				console.log(e);
				if (!e.childrenList&&e.serialCode) {


					console.log(this.pageNo)
					const { data }=await ezvizUrl({
						deviceCode: e.serialCode,
						channelCode: e.channelCode,
						ezvizId: '1719992852546715650'
					})
					this.loading = false
					if (data.code == 200) {
						if (this.videoList.length > 0 && this.videoList.length % this.pageSize == 0) {
							console.log('再加一页')
							this.pageNo = this.pageNo + 1
							this.currentPage = this.currentPage + 1
					
							console.log(this.currentPage)
							this.initPlayer()
						}
						this.videoList.push({
							ezvizId: '1719992852546715650',
							deviceCode: e.serialCode,
							channelCode: e.channelCode,
							accessToken: data.result.accessToken,
							url: data.result.url
						})
						this.playerList.push({
							loading: true,
							player: null
						})
					
					
						// this.$nextTick(()=>{
					
						this.createDom(data.result.accessToken, data.result.url, this.playerList.length - 1)
						// })
					
					}else{
						Message.error(data.message);
					}
					
					
					

				}
				console.log(this.videoList)

			},
			createDom(accessToken, url, i) {
				var domain = "https://open.ys7.com";

				this.$nextTick(() => {
					//   window.EZOPENDemo = EZOPENDemo;
					this.loading = true
					let eleId = 'playWind-' + (i)
					console.log(i)
					let w = document.querySelector('.myPlayWind').clientWidth
					let h = document.querySelector('.myPlayWind').clientHeight
					console.log(w)

					let player = new EZUIKit.EZUIKitPlayer({
						id: eleId,
						width: w,
						height: h,
						template: "mobileLive",
						url: url,
						accessToken: accessToken,
						handleSuccess: (res) => {
							console.log(i)
							this.playerList[i] = {
								player: player,
								loading: false
							}
							let flag = true
							this.playerList.forEach(item => {
								if (item.loading) {
									flag = false
								}
							})
							if (!flag) {
								this.loading = true
							} else {
								this.loading = false
							}
						},
						handleError: (res) => {
							console.log('fail', res)
						},
					});

				})




			},




		},




	};
</script>



<style lang="scss" scoped>
	.watch-main {
		display: flex;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.watch-left {
		width: 3.44rem;
		padding-left: 0.25rem;
		display: flex;
		overflow: hidden;

		.watch-panel {
			display: flex;
			height: 2rem;
			flex-wrap: wrap;
			align-items: center;
			border-bottom: 0.01rem solid #0C264A;

			.panel-item {
				display: flex;
				width: 50%;
				height: 0.53rem;

				.panel-value {
					height: 0.25rem;
					font-size: 0.25rem;
					font-family: DIN-Bold, DIN;
					font-weight: 700;
					color: #FFFFFF;
					line-height: 0.25rem;
				}

				.panel-name {
					height: 0.18rem;
					font-size: 0.15rem;
					font-family: Source Han Sans-Regular, Source Han Sans;
					font-weight: 400;
					color: rgba(255, 255, 255, 0.69);
					line-height: 0.18rem;
				}

				.panel-icon {
					width: 0.5rem;
					margin-right: 0.16rem;
				}

				.panel-value-active {
					height: 0.2rem;
					font-size: 0.2rem;
					font-family: DIN-Bold, DIN;
					font-weight: 700;
					color: #FFBB00;
					line-height: 0.2rem;
				}
			}
		}

		.watch-menu {
			overflow-y: scroll;
			height: 100%;
			flex: 1;

			.el-tree {
				background: rgba(0, 0, 0, 0);


			}

			.custom-node-text-leaf {
				padding-left: 0.26rem;
				height: 0.28rem;
				font-size: 0.18rem;
				font-family: Source Han Sans-Medium, Source Han Sans;
				font-weight: 500;
				color: #19ECFF;
				line-height: 0.28rem;
			}

			.custom-node-text-noleaf {
				height: 0.28rem;
				font-size: 0.18rem;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 0.28rem;
				margin-left: 0.01rem;
			}

			::v-deep .el-tree-node__content:hover {
				background-color: rgba(25, 236, 255, 0.1);

			}

			::v-deep .el-tree-node:focus>.el-tree-node__content {
				background: rgba(25, 236, 255, 0.1);
			}

			::v-deep .el-tree-node__content {
				height: 0.65rem;

			}
		}

	}

	.watch-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 100%;

		.video-warp {
			flex: 1;
			height: 0;
		}

		.video-list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			height: 100%;
			padding-right: 0.38rem;
			// 

		}

		.video-item {
			padding-left: 0.38rem;
			padding-top: 0.19rem;
			padding-bottom: 0.19rem;

			img,
			.myPlayWind {
				width: 100%;
				height: 100%;
			}

		}

		.video-item-4 {
			width: 50%;
			height: 50%;
			// height: 3rem;
			// padding-left: 0.38rem;
		}

		.video-item-9 {
			width: 33.33%;
			height: 33.33%;
			// height: 3rem;
			// padding-left: 0.38rem;
		}

		.video-item-16 {
			width: 25%;
			height: 25%;
			// height: 3rem;
			// padding-left: 0.38rem;
		}

		.pagination {
			padding-bottom: 0.2rem;
			padding-right: 0.25rem;
			display: flex;
			justify-content: flex-end;

		}
	}
	
	
	::v-deep  .el-pagination.is-background .btn-next,::v-deep  .el-pagination.is-background .btn-prev,::v-deep  .el-pagination.is-background .el-pager li{
		background-color:rgba(0,0,0,0);
		border: 0.01rem solid #FFFFFF;
		border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
		color:#fff;
	}
	::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
		background: #19ECFF;
		border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
		border: 0.01rem solid #19ECFF;
		color: #1B293E;
	}
</style>